import { render, staticRenderFns } from "./KnittingDeliveryView.vue?vue&type=template&id=c2ca5676&scoped=true"
import script from "./KnittingDeliveryView.vue?vue&type=script&lang=js"
export * from "./KnittingDeliveryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ca5676",
  null
  
)

export default component.exports